//src/components/Analytics.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, isGAInitialized } from '../utils/analytics';

function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Only track if GA is initialized (user consented to analytics)
    if (isGAInitialized()) {
      trackPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
}

export default Analytics;